<template>
	<tr>
		<td>{{ index + 1 }}.</td>
		<td v-if="isShowColumn('id')">
			<a
				role="button"
				class="order-order-id"
				@click="showDetails(order, $event)"
			>
				<div class="text-bold">#{{ order.order_id }}</div>
			</a>
			<!-- Order Type -->
			<div>Type: {{ order.type }}</div>
			<!-- Restore Deleted Order -->
			<!-- button restore hide by request  -->
			<!-- <button
				class="btn btn-light btn-sm mt-2"
				:class="{ 'is-loading': isRestoring }"
				:disabled="isRestoring"
				@click="restoreOrder(order.order_id)"
				v-tooltip="$t('Restore Deleted Order')"
				v-if="order.is_deleted && isUserCan('admin_monitoring_orders_action_restore')"
			>
				{{ $t('Restore') }}
			</button> -->
		</td>
		<td v-if="isShowColumn('reference_id')">
			#{{ order.reference_id }}
		</td>
		<td v-if="isShowColumn('product_name')">
			<span class="cursor-pointer" v-tooltip="'Lihat harga produk pada order ini'" @click="showProduct(order)" >
				<div
					class="submission-product-name"
					v-if="order.type === 'form'">
					{{ order.product_name }}
				</div>
				<div v-else-if="order.cart_items">
					<div
						class="mb-2"
						v-for="(cartItem, index) in order.cart_items"
						:key="index">
						{{ cartItem.product_name }} (x{{ cartItem.qty }})
					</div>
				</div>
			</span>
		</td>
		<td
			class="fitwidth"
			v-if="isShowColumn('product_code')"
		>
			<div
				class="submission-product-name"
			>
				<template v-if="order.type === 'form'">
					{{ order.product_code ? order.product_code : '' }}
				</template>
				<template v-else>
					<template v-if="getProductCode(order.products).length > 0">
						<div v-for="(code, idx) in getProductCode(order.products)" :key="idx">
							{{ code }}
						</div>
					</template>
				</template>
			</div>
		</td>
		<td v-if="isShowColumn('variations')">
			<div
				class="submission-variations"
				v-if="order.customer_data"
			>
				<template v-if="order.type === 'form'">
					<div
						class="d-flex flex-column"
						v-if="
							order.customer_data.variations &&
							order.customer_data.variations.length > 0
						"
					>
						<span
							class="mb-2"
							v-for="(itemVar, varIndex) in customerDataVariations(
								order.customer_data.variations,
								true,
							)"
							:key="varIndex"
							>{{ itemVar.name }} (x{{ itemVar.quantity }})</span
						>
					</div>
					<div
						class="d-flex flex-column"
						v-else-if="
							order.customer_data.variation &&
							order.customer_data.variation !== ''
						"
					>
						<span
							class="mb-2"
							v-for="(itemVar, varIndex) in customerDataVariations(
								order.customer_data.variation,
								false,
							)"
							:key="varIndex"
							>{{ itemVar }}</span
						>
					</div>
				</template>
				<order-items :items="order.cart_items" v-else>
				</order-items>
			</div>
		</td>
		<td v-if="isShowColumn('quantity')">
			<div class="submission-quantity">
				{{ getQuantity(order) }}
			</div>
		</td>
		<td v-if="isShowColumn('status')">
			<mark :class="`order-status status-${getOrderDisplayStatus(order).style}`">
				<span>{{ getOrderDisplayStatus(order).label }}</span>
			</mark>
		</td>
		<td v-if="isShowColumn('payment_status')">
			<mark
				class="payment-status pill"
				:class="`pill-${
					order.payment && order.payment.status === 'paid'
						? 'success'
						: 'danger'
				}`"
			>
				<span>{{ order.payment.status }}</span>
			</mark>
		</td>
		<td v-if="isShowColumn('payment_info')">
			{{ order.payment.method }}
		</td>
		<td v-if="isShowColumn('supplier')">
			<div>{{ order.supplier_name }} ({{ order.supplier_username || '-' }})</div>
			<div>
				<a :href="`https://wa.me/62${validatePhoneNumber(order.supplier_phone)}`" target="_blank">
					+62{{ validatePhoneNumber(order.supplier_phone) }}
				</a>
			</div>
		</td>
		<td v-if="isShowColumn('seller')">
			<div>{{ order.seller_name }} ({{ order.seller_username || '-' }})</div>
			<div>
				<a :href="`https://wa.me/62${validatePhoneNumber(order.seller_phone)}`" target="_blank">
					+62{{ validatePhoneNumber(order.seller_phone) }}
				</a>
			</div>
		</td>
		<td v-if="isShowColumn('customer_name')">
			<div>
				<div class="text-bold">{{ order.customer_data.name }}</div>
				<div>
					<a :href="`https://wa.me/62${ validatePhoneNumber(order.customer_data.phone)}`" target="_blank">
						+62{{ validatePhoneNumber(order.customer_data.phone) }}
					</a>
					</div>
			</div>
		</td>
		<td v-if="isShowColumn('customer_email')">
			<div
				class="submission-customer-email"
				v-tooltip="order.customer_data.email"
				v-if="
					order.customer_data.email &&
					order.customer_data.email !== ''
				"
			>
				<a
					:href="`mailto:${order.customer_data.email}`"
					target="_blank"
					>{{ order.customer_data.email }}</a
				>
			</div>
			<div class="submission-customer-email" v-else>-</div>
		</td>
		<td v-if="isShowColumn('city')">
			<div class="shipment-address" v-if="order.customer_data">
				<div>{{ order.customer_data.province_name }}</div>
				<div>{{ order.customer_data.city_name }}</div>
				<div>{{ order.customer_data.subdistrict_name }}</div>
				<div>{{ order.customer_data.address }}</div>
			</div>
		</td>
		<td v-if="isShowColumn('courier')">
			{{ order.shipping.courier }}
		</td>
		<td v-if="isShowColumn('receipt_number')">
			<div class="submission-receipt-number">
				<span @click="showShippingTracking(order)" v-tooltip="'Lacak'" class="cursor-pointer">{{ order.shipping.receipt_number }}</span>
			</div>
			<!-- {{ order.shipping.receipt_number }} -->
		</td>
		<td class="text-right" v-if="isShowColumn('net_revenue')">{{ formatMoney(order.net_revenue) }}</td>
		<td class="text-right" v-if="isShowColumn('shipping_cost')">{{ formatMoney(order.shipping.cost) }}</td>
		<td class="text-right" v-if="isShowColumn('cod_fee')">
			<span v-if="order.shipping.cod">{{ formatMoney(order.shipping.cod_cost) }}</span>
			<span v-else>Rp0</span>
		</td>
		<td class="text-right" v-if="isShowColumn('shipping_markup')">
			{{ formatMoney(order.shipping.markup) }}
		</td>
		<td class="text-right" v-if="isShowColumn('unique_code')">
			{{ formatMoney(order.unique_code_price.unique_code) }}
		</td>
		<td class="text-right" v-if="isShowColumn('commission_fee')">
			{{ getCommissionFee(order) }}
		</td>
		<td class="text-right" v-if="isShowColumn('total_price')">{{ formatMoney(order.gross_revenue) }}</td>
		<td class="text-center" v-if="isShowColumn('date_ordered')">
			<div class="order-date">{{ showDate(order.ordered_at) }}</div>
		</td>
		<td class="text-center" v-if="isShowColumn('date_created')">
			<div class="order-date">{{ formatDate(order.created_at) }}</div>
		</td>
		<td class="text-center" v-if="isShowColumn('date_processing')">
			<div class="order-date">{{ showDate(order.processing_at) }}</div>
		</td>
		<td class="text-center" v-if="isShowColumn('date_manifested')">
			<div class="order-date">{{ showDate(order.manifested_at) }}</div>
		</td>
		<td class="text-center" v-if="isShowColumn('date_delivered')">
			<div class="order-date">{{ showDate(order.delivered_at) }}</div>
		</td>
		<td class="text-center" v-if="isShowColumn('shipping.returned_at')">
			<div class="order-date">{{ showDate(order.shipping.returned_at) }}</div>
		</td>
		<td class="text-center" v-if="isShowColumn('date_refunded')">
			<div class="order-date">{{ showDate(order.refunded_at) }}</div>
		</td>
		<td class="text-center" v-if="isShowColumn('date_cancelled')">
			<div class="order-date">{{ showDate(order.cancelled_at) }}</div>
		</td>
		<td v-if="isShowColumn('actions')">
			<div class="submission-actions">
				<div class="dropdown">
					<button
						type="button"
						class="btn btn-sm btn-light dropdown-toggle"
						data-toggle="dropdown"
						data-display="static"
						aria-haspopup="true"
						aria-expanded="false"
					>
						Actions
					</button>
					<div class="dropdown-menu dropdown-menu-right">
						<!-- Pending -->
						<!-- <button
							type="button"
							class="dropdown-item"
							@click="showMarkPending(submission)"
							:disabled="submission.status === 'pending'"
							v-if="isUserCan('order_update_pending')"
						>
							Mark as Pending
						</button> -->

						<!-- Processing -->
						<!-- <button
							type="button"
							class="dropdown-item"
							@click="showMarkProcessing(submission)"
							:disabled="submission.status === 'processing'"
							v-if="isUserCan('order_update_process')"
						>
							Mark as Process
						</button> -->

						<!-- Complete -->
						<!-- <button
							type="button"
							class="dropdown-item"
							@click="showMarkComplete(submission)"
							:disabled="submission.status === 'completed'"
							v-if="isUserCan('order_update_complete')"
						>
							Mark as Complete
						</button> -->

						<!-- Refund -->
						<button
							type="button"
							class="dropdown-item"
							@click="confirmRefund(order)"
							:disabled="!isRefundAllowed(order)"
						> <!-- Because only one action is provided, it's better to disable than hide the action if user doesn't have required capability -->
							Mark as Refund
						</button>

						<!-- Cancel -->
						<!-- <button
							type="button"
							class="dropdown-item"
							@click="showMarkCancel(submission)"
							:disabled="submission.status === 'cancelled'"
							v-if="isUserCan('order_update_cancel')"
						>
							Mark as Cancel
						</button> -->

						<!-- <div class="dropdown-divider"></div> -->

						<!-- Paid -->
						<!-- <button
							type="button"
							class="dropdown-item"
							@click="showMarkPaid(submission)"
							:disabled="
								submission.payment.status === 'paid' ||
									submission.payment.method === 'instant'
							"
							v-if="
								isUserCan('order_update_paid') && submission.payment
							"
						>
							Mark as Paid
						</button> -->

						<!-- Unpaid -->
						<!-- <button
							type="button"
							class="dropdown-item"
							@click="showMarkUnpaid(submission)"
							:disabled="
								submission.payment.status === 'unpaid' ||
									submission.payment.method === 'instant'
							"
							v-if="
								isUserCan('order_update_unpaid') && submission.payment
							"
						>
							Mark as Unpaid
						</button> -->
					</div>
				</div>
			</div>
		</td>
		<td v-if="isUserCan('admin_monitoring_orders_action_refund')">
			<button
				type="button"
				class="btn btn-sm btn-primary"
				:class="{'is-loading': isRefundingCredit}"
				v-if="isRefundCreditAllowed(order)"
				@click="confirmRefundCredit(order)"
			>
				Refund
			</button>
		</td>
	</tr>
</template>

<script>
import { mapGetters } from 'vuex';
import {
	copyToClipboard,
	generateVariationsData,
	getAxiosErrorMessage,
	getOrderDisplayStatus,
	validatePhoneNumber,
} from '@/lib/helper';
import adminApi from '@/api/admin';
import OrderItems from '@/components/OrderItems.vue';

export default {
	name: 'OrdersSearchRow',
	components: {
		OrderItems,
	},
	props: {
		index: {
			type: Number,
		},
		order: {
			type: Object,
		},
		columns: {
			type: Array,
		},
	},
	data() {
		return {
			isRefunding: false,
			isRestoring: false,
			isRefundingCredit: false,
		};
	},
	methods: {
		validatePhoneNumber,
		showDetails(order, event) {
			this.$emit('detail', order, event);
		},
		refundShippingCost(orderId) {
			this.isRefunding = true;
			const callback = () => {
				const message = 'Refund success';
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Shipping Cost',
					text: message,
				});
				this.$emit('refund', this.order);
				this.isRefunding = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Shipping Cost',
					text: message,
				});
				this.isRefunding = false;
			};
			adminApi.refundShippingCost(orderId, callback, errorCallback);
		},
		formatDate(dateString) {
			const format = 'DD-MM-YYYY - HH:mm';
			const timezone = this?.user?.timezone ?? 'Asia/Jakarta';
			// const formattedDate = this.moment.utc(dateString).local().format(format);
			const formattedDate = this.moment
				.utc(dateString)
				.tz(timezone)
				.format(format);
			return dateString && dateString !== '' ? formattedDate : '';
		},
		copy(text) {
			copyToClipboard(text);
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Success',
				text: 'copied to clipboard',
			});
		},
		restoreOrder(orderId) {
			this.isRestoring = true;
			const callback = () => {
				const message = 'Restore success';
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Restore',
					text: message,
				});
				this.$emit('restore', orderId);
				this.isRestoring = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Restore',
					text: message,
				});
				this.isRestoring = false;
			};
			const orderIds = [orderId];
			adminApi.restoreOrders(orderIds, callback, errorCallback);
		},
		customerDataVariations(val, multiple) {
			return generateVariationsData(val, multiple);
		},
		showShippingTracking(order) {
			return this.$emit('track', order);
		},
		showProduct(order) {
			return this.$emit('showProduct', order);
		},
		getOrderDisplayStatus,
		isShowColumn(key) {
			return this.columns.includes(key);
		},
		getQuantity(order) {
			let quantity = 1;
			if (order.type === 'storefront') {
				quantity = order.cart_items.reduce(
					(total, cartItem) => total + cartItem.qty,
					0,
				);
			} else {
				quantity = order.customer_data.quantity || 1;
				if (order.customer_data.variations) {
					quantity = order.customer_data.variations.reduce(
						(accumulator, variation) => {
							const variationQuantity = variation.quantity || 1;
							return accumulator + variationQuantity;
						},
						0,
					);
				}
			}
			return quantity;
		},
		confirmRefund(order) {
			this.$emit('refund', order);
		},
		confirmRefundCredit(order) {
			this.$emit('refundCredit', order, true);
		},
		isRefundAllowed(order) {
			const isRoleAllowed = this.isRoleSuperAdmin || this.isRoleFinance; // allow if user role is superadmin or finance
			const isNotRefundedStatus = order.status !== 'refunded'; // allow if status is not refunded
			const hasUpdateRefundCapability = this.isUserCan('order_update_refund'); // allow if user has order_update_refund capability
			return isRoleAllowed && isNotRefundedStatus && hasUpdateRefundCapability; // return true if allowed
		},
		isRefundCreditAllowed(order) {
			const isNotRefundedStatus = order?.status !== 'refunded';
			const isValidPayment = (order?.payment?.method === 'instant' || order?.payment?.method === 'bank_transfer');
			return isNotRefundedStatus && isValidPayment;
		},
		getCommissionFee(order) {
			const totalCommissionFee = order?.total_commission || 0;
			return this.formatMoney(totalCommissionFee);
		},
		getProductCode(products) {
			let productCodeArray = [];
			if (products.length > 0) {
				productCodeArray = products.map(product => (product.product_code ? product.product_code : '-'));
			}
			return productCodeArray;
		},
		showShippingReturnedAt(order) {
			return order?.shipping?.returned_at ?? '-';
		},
		showDate(date) {
			if (date && date?.$date?.$numberLong) {
				return this.formatDateFromNumberLong(date.$date);
			}
			if (date && date?.$date) {
				return this.formatDate(date.$date);
			}
			return this.formatDate(date) ?? '-';
		},
		formatDateFromNumberLong(timestamp) {
			const date = new Date(parseInt(timestamp.$numberLong));

			const year = date.getFullYear();
			const month = (`0${date.getMonth() + 1}`).slice(-2);
			const day = (`0${date.getDate()}`).slice(-2);

			const hours = (`0${date.getHours()}`).slice(-2);
			const minutes = (`0${date.getMinutes()}`).slice(-2);

			const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;

			return formattedDate;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isUserCan: 'isUserCan',
			isRoleSuperAdmin: 'isRoleSuperAdmin',
			isRoleFinance: 'isRoleFinance',
		}),
		isRefundValid() {
			const isInstant = this.order?.payment?.method === 'instant';
			const isPaid = this.order?.payment?.status === 'paid';
			// eslint-disable-next-line camelcase
			const isShippingDeducted = this.order?.payment?.shipping_deducted;
			const isPickedUp = this.order?.shipping?.pickup;
			const isValid = isInstant && isPaid && !isPickedUp && isShippingDeducted;
			return isValid;
		},
	},
};
</script>
